import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'

import Accordion from 'src/components/Organisms/Accordion/Accordion'
import { ExternalLink } from 'src/components/Core/Styles/Link'
import Font from 'src/components/Core/Typography/Font/Font'

const AccordionMiFID = (
  <Accordion
    key='MiFID'
    title={t('onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.visualOnly.MiFID.title')}
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.visualOnly.MiFID.content'} />
  </Accordion>
)

const LEIregulatoryOversightText = (
  <Font
    key='LEIregulatoryOversight'
    ellipsis={false}
  >
    {<Trans i18nKey={'onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.visualOnly.LEIregulatoryOversight'} />}
  </Font>
)

export const aboutClientDocumentationLink = <ExternalLink href='https://www.sucdenfinancial.com/en/about/client-documentation'>www.sucdenfinancial.com/en/about/client-documentation</ExternalLink>
export const clientDocumentationLink = <ExternalLink href='https://www.sucdenfinancial.com/en/client-documentation-and-disclosures/'>www.sucdenfinancial.com/en/client-documentation-and-disclosures/</ExternalLink>

const AccordionImportantNote = (
  <Accordion
    key='importantNote'
    title={t('onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.visualOnly.importantNote.title')}
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.visualOnly.importantNote.content'} components={{ aboutClientDocumentationLink, clientDocumentationLink }}/>
  </Accordion>
)

const config = utils.injectTranslation({
  id: 'LegalEntityIdentifierForm',
  path: 'onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.inputs',
  keysToRemove: ['visual'],
  content: [
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px'
      },
      content: [
        {
          componentType: 'radioButton',
          props: {
            name: 'eLEIStatus',
            id: 'haveLEI',
            value: 'haveLEI',
            //@ts-ignore 
            label: <Trans i18nKey={'onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.radioOptions.haveLEI'} />,
            display: 'inline',
            minWidth: '24px',
            marginWrapper: '8px 0 0 0'
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginLeft: '4%',
        width: '96%'
      },
      content: [
        {
          componentType: 'input',
          submitValidation: 'lei',
          props: {
            name: 'leiNumber',
            required: true,
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: '16px'
      },
      content: [
        {
          componentType: 'radioButton',
          props: {
            name: 'eLEIStatus',
            id: 'notHaveLEI',
            value: 'notHaveLEI',
            label: <Trans i18nKey={'onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.radioOptions.notHaveLEI'} />,
            display: 'inline',
            minWidth: '24px',
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        rowGap: '16px'
      },
      content: [
        {
          componentType: 'accordion',
          visualComponent: AccordionMiFID
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'doYouHaveParentCompany',
            dataList: [
              {
                id: 'doYouHaveParentCompany1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'doYouHaveParentCompany2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        marginLeft: '4%',
        width: '96%'
      },
      content: [
        {
          componentType: 'input',
          submitValidation: 'lei',
          props: {
            name: 'parentLEINumber',
            required: true,
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        rowGap: '24px'
      },
      content: [
        {
          componentType: '',
          visualComponent: LEIregulatoryOversightText
        },
        {
          componentType: 'accordion',
          visualComponent: AccordionImportantNote
        },
      ]
    },
  ],
})

export default config
